<app-profile-header></app-profile-header>

<section class="body-section">
    <div class="container">
        <main>
            <div class="bottom-container Transaction-table ">
                <div class="box transaction-box ">
                    <div class="header-container">
                        <h3 class="section-header">My Achivements</h3>
                    <!-- <div class="search-bar">
                     
                        <p-button (click)="op.toggle($event)" icon="pi pi-search" class="searchBar-mobile"></p-button>
                        <p-overlayPanel #op>
                            <ng-template pTemplate="content">
                              <div class="mobile-version-search">
                                <label for="search_bar" class="search-bar">
                                    <div class="icon">
                                        <i class="bx bx-search"></i> 
                                    </div>
                                    <input type="search" placeholder="Search Touranment ">
                                </label>
                              </div>
                            </ng-template>
                        </p-overlayPanel>
                        <label for="search_bar" class="search-bar">
                            <div class="icon">
                                <i class="bx bx-search"></i> 
                            </div>
                            <input type="search" placeholder="Search Touranment ">
                        </label>
                    </div> -->
                    </div>
                    <div class="tables-sectionss">
                        <p-table id="vdtnetable10" #dt [value]="matchList" [paginator]="true" [rows]="10"
                            [rowsPerPageOptions]="paginationOption" [lazy]="true" scrollHeight="auto"
                            scrollDirection="horizontal" [totalRecords]="totalRecords" [loading]="loading"
                            [scrollable]="true" cellpadding="0" class="transaction-history" pageLinks="3" [showPageLinks]="true"
                            (onLazyLoad)="getMyTournamentList($event)" aria-describedby="vdtnetable10_info">
                            <ng-template pTemplate="header">
                                <tr>

                                    <th pSortableColumn="tournamentName"
                                        class="rin-dt-align-left sorting_disabled rin-dt-ellpsis-overflow-1" rowspan="1"
                                        colspan="1" style="color: black;background-color: white;">
                                        <div>Tournament Name
                                            <p-sortIcon field="tournamentName"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="matchName" class="sorting_disabled" rowspan="1" colspan="1">
                                        <div>Categories
                                            <p-sortIcon field="matchName"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="agegroupName" class="sorting_disabled" rowspan="1" colspan="1">
                                        <div>Age Group
                                            <p-sortIcon field="agegroupName"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="entryFee" class="sorting_disabled" rowspan="1" colspan="1">
                                        <div>Entry Fees
                                            <p-sortIcon field="entryFee"></p-sortIcon>
                                        </div>
                                    </th>

                                    <th pSortableColumn="lastdateofwithdraw" class="sorting_disabled" rowspan="1"
                                        colspan="1">
                                        <div>Position
                                            <p-sortIcon field="lastdateofwithdraw"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="tournamentEndDate" class="sorting_disabled" rowspan="1"
                                        colspan="1">
                                        <div> Date
                                            <p-sortIcon field="tournamentEndDate"></p-sortIcon>
                                        </div>
                                    </th>
                                    <!-- <th pSortableColumn="tournamentStatus" class="sorting_disabled" rowspan="1"
                                        colspan="1" >
                                        <div>Status
                                            <p-sortIcon field="tournamentStatus"></p-sortIcon>
                                        </div>
                                    </th> -->
                                    <th class="sorting_disabled" rowspan="1" colspan="1">
                                        <div>Action

                                        </div>
                                    </th>

                                </tr>
                            </ng-template>

                            <ng-template pTemplate="body" let-matchList>
                                <tr>
                                    <td>
                                        <span class="mobile-label-div">
                                          Tournament Name:
                                        </span>
                                        <a class="rin-type-label state-finished" style=" cursor: pointer;"
                                            pTooltip="{{matchList.tournamentName}}" tooltipPosition="bottom"
                                            (click)="onclickTournamentdetails(matchList.tournamentId)">
                              
                                            {{matchList.tournamentName}}
                                        </a></td>
                                    <td>
                                        <span class="mobile-label-div">
                                            Categories:
                                          </span>
                                        <span class="rin-type-label state-finished">
                                            {{matchList.matchName}}
                                        </span></td>
                                    <td>
                                        <span class="mobile-label-div">
                                            Age Group:
                                          </span>
                                        <span class="rin-type-label state-finished">
                                        
                                            {{matchList.ageGroupName}}
                                        </span></td>
                                    <td>
                                        <span class="mobile-label-div">
                                            Entry Fees:
                                          </span>
                                        <span class="rin-type-label state-finished">
                                            ₹ {{matchList.entryFee}}
                                        </span></td>

                                    <td>
                                        <span class="mobile-label-div">
                                            Position:
                                          </span>
                                        <span class="rin-type-label state-finished">
                                          {{matchList.position}}
                                        </span></td>
                                    <td>
                                        <span class="mobile-label-div">
                                            End Date:
                                          </span>
                                        <span class="rin-type-label state-finished">
                                            {{matchList.tournamentEndDate | date : 'dd-MM-yyyy'}}
                                        </span></td>
                                    <!-- <td><span class="rin-type-label state-finished">
                                            {{matchList.tournamentStatus}}
                                        </span></td> -->
                                    <td>
                                        <div class="status-buttons">
                                            <button *ngIf="matchList.certificatePic" class="btn btn-success"
                                                (click)="downloadPdf(matchList.certificatePic)"
                                                id="withdrawal-btn"><span><i class='bx bx-download'></i></span>
                                                Download Certificate</button>
                                        </div>
                                        <!-- <div class="disableBtn status-buttons" *ngIf="matchList.showWithdraw == false"
                                            pTooltip="Withdrawal Date Expired" tooltipPosition="top">
                                            <button class="btn btn-success"
                                                (click)="withdrawModal(matchList.id,matchList.tournamentName,matchList.matchName,matchList.ageGroupName)"
                                                id="withdrawal-btn" disabled><span><i class="bx bx-exit"></i></span>
                                                Withdraw</button>
                                        </div> -->
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="summary">
                                <div class="p-d-flex p-ai-center p-jc-between">
                                    Total {{totalRecords }} Achivements
                                </div>
                            </ng-template>
                        </p-table>
                    </div>



                </div>
            </div>



        </main>
    </div>
</section>
<p-dialog id="Entertournamentthank" [(visible)]="thankwithdrawinfo"
    [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [style]="{ width: '38rem' }" [modal]="true"
    [draggable]="false" [resizable]="false">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
    max-width: 100%;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="EntertournamentLabel">Tournament Withdraw</h5>
                <div class="headings col-md-12">

                    <h6>{{tname}}</h6>


                    <div class="countdown-container">
                        <div class="countdown-circle" [style.animation-duration.seconds]="10"></div>
                        <div class="countdown-text">{{ countdown }}</div>
                        <br>

                    </div>
                    <div class="timer-alert">
                        Please wait
                    </div>
                    <p class="note">We are processing your request for a refund in the tournament category. Once the
                        refund
                        process is successfully completed, please check wallet Balance.</p>

                </div>

            </div>
        </div>
    </div>
</p-dialog>

<!-- <p-dialog id="widthdraw-confitmation" [(visible)]="WithdrawcnfModal"
    [breakpoints]="{ '960px': '75vw' , '768px': '100%'}" [style]="{ width: '38rem' }" [modal]="true" [draggable]="false"
    [resizable]="false">
   

    <div class="modal-dialog w-100 modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important; width: 100%;
    max-width: 100%;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="EntertournamentLabel">Withdraw Confirmation
                </h5>
            </div>
            <div class="modal-body">

                <p>
                    Are you sure you want to withdraw from the tournament? Please note that this action cannot be
                    undone, and your participation in the tournament will be cancelled.
                </p>


                <div class="add-even col-md-12">
                   

                    <div class="event-details-list">
                        <div class="list-div-selection">
                            <div class="event-details">
                                <div class="title">{{tname}}</div>
                                <div class="Event-cate">
                                    <ul>
                                        <li>
                                            <span class="small-heading">{{mtn}}</span>
                                            <p>{{agn}}</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                    </div>
                    <p>
                        After the withdrawal, the entry fee amount will be credited back to your TPL wallet.
                    </p>


  

                </div>
            </div>
            <div class="modal-footer">

                <button type="button" class="btn btn-primary mx-auto " (click)="thankyouwithdraw()">Proceed with the
                    withdrawal</button>
            </div>
        </div>


    </div>

</p-dialog>
<p-dialog id="Entertournamentthankadmin" [(visible)]="thankwithdraw"
    [breakpoints]="{ '960px': '75vw', '768px': '100%' }" [style]="{ width: '500px' }" [modal]="true" [draggable]="false"
    [resizable]="false">
  

    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
    max-width: 100%;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="EntertournamentLabel">Tournament Withdraw</h5>
                <div class="headings col-md-12">
                    <h6></h6>
                    <p class="note">Your Tournament withdrawals have been successfully processed.</p>
                </div>

            </div>

        </div>


    </div>

</p-dialog> -->